import Injectable from '@/modules/shared/domain/di/injectable';
import { UpdateCellPhoneRepository } from '../../../domain/repository/update-cell-phone-repository';

@Injectable()
export default class UpdateCellPhoneDummyRepository implements UpdateCellPhoneRepository {
  execute(): Promise<void> {
    return Promise.resolve();
  }
}
